import { addPromotionBackend } from "../../api";
import {
  checkMinBasketPrice,
  isStringNotNull,
  renderErrorMessage,
} from "../../utils";
import store from "../../redux/store";
import { showConnexionModal } from "../../redux/actions";
import { analyticsEvents } from "../../utils/firebaseAnalytics";
import { logLowLog, logMediumError } from "../../utils/logger";
import _ from "lodash";
import { PROMOTION_DELIVERY_FREE } from "../../constants";
import { openMessageModal } from "../../utils/common";

export const addPromotion = async (
  setLoadingPromotion: React.Dispatch<React.SetStateAction<boolean>>,
  setMessage: React.Dispatch<React.SetStateAction<string>>,
  promoCode: string,
  totalPriceOrder: number
) => {
  const minBasketPrice = await checkMinBasketPrice(promoCode, totalPriceOrder);
  try {
    const { user, userConnected } = store.getState().userReducer;
    const { customerId } = user;
    setMessage("");
    setLoadingPromotion(true);
    if (isStringNotNull(promoCode)) {
      if (userConnected) {
        logLowLog(`Adding code promo ${promoCode}`);
        const promo = await addPromotionBackend(
          customerId,
          promoCode,
          customerId
        );
        if (promo?.downloadAppLink) {
          openMessageModal(
            `Ce code promotionnel n'est valable que sur notre application mobile que vous pouvez télécharger
                  <a href="${promo.downloadAppLink}" target='_blank' rel='noopener noreferrer'> 
                   ici
                  </a>`
          )
        } else {
          analyticsEvents.logPromoCodeAdded("cartView", "promoCode");

          const { promotions: shopPromotions } = store.getState().shopReducer;
          const actualPromotion = shopPromotions?.[promoCode];

          const isFreeDelivery =
            actualPromotion?.type === PROMOTION_DELIVERY_FREE;
          const actualPromoCode = actualPromotion?.promoCode || promoCode;

          let message = "";
          if (isFreeDelivery) {
            message = `Votre code promotionnel "${actualPromoCode}" a bien été ajouté. La livraison vous sera offerte.`;
            if (minBasketPrice) {
              message += ` Pour profiter de cette offre, votre panier doit être supérieur à ${minBasketPrice}€`;
            }
          } else {
            message = `Votre code promotionnel "${actualPromoCode}" a bien été ajouté.`;
            if (minBasketPrice) {
              message += ` Pour profiter de ce code promotionnel, votre panier doit être supérieur à ${minBasketPrice}€`;
            }
          }
          openMessageModal(message);
        }
      } else {
        store.dispatch(showConnexionModal(true));
      }
    } else {
      store.dispatch(
        openMessageModal(`Vous devez entrer un code promotionnel.`)
      );
    }
    setLoadingPromotion(false);
  } catch (error) {
    const errorMessage = String(error);
    const promotion = store.getState().shopReducer.promotions?.[promoCode];
    setLoadingPromotion(false);
    let message = renderErrorMessage(errorMessage, null);
    if (
      promotion &&
      Object.hasOwn(promotion, "startedDate") &&
      Object.hasOwn(promotion, "endedDate")
    ) {
      const validDates = {
        startedDate: promotion.startedDate,
        endedDate: promotion.endedDate,
      };
      message = renderErrorMessage(errorMessage, validDates);
    }
    setMessage(message);
    logMediumError(`Error adding promotion ${error}`);
  }
};
